import { useState, useEffect, useContext } from 'react';
import useApi from '../../../../utils/api-manager/Helper/useApi';
import AuthContext from "../../../../utils/secure-route/AuthContext";
import { useToastHandler } from '../../../common/ToastHandler';
import useFormattingUtils from "../../../../context/useFormattingUtils";


const BiometricController = () => {
  const [paySalaryModal, setPaySalaryModal] = useState(false);
  const [employees, setEmployees] = useState([]);
  const [selectedEmployee, setSelectedEmployee] = useState("");
  const [payAmount, setPayAmount] = useState("");
  const [baseAmount, setBaseAmount] = useState("");
  const [calculatedHours, setCalculatedHours] = useState(null);
  const [users, setUsers] = useState([]);
  const [payrollEmployees, setPayrollEmployees] = useState([]);
  const [selectedEmployeeId, setSelectedEmployeeId] = useState("");
  const [selectedBioEmployeeId, setSelectedBioEmployeeId] = useState(null);
  const [username, setUsername] = useState("");
  const [payType, setPayType] = useState("");
  const [dateFrom, setDateFrom] = useState("");
  const [dateTo, setDateTo] = useState("");
  const [workingHoursPerDay, setWorkingHoursPerDay] = useState("");
  const [dailyLog, setDailyLog] = useState([]);
  const [biomatricSalary, setBioMatricSalary] = useState([]);
  const [editSalaryData, setEditSalaryData] = useState(null);
  const [salaryHistoryRefreshKey, setSalaryHistoryRefreshKey] = useState(0);
  const [loading, setLoading] = useState(false);
  const [openPrint, setOpenPrint] = useState(false);
  const [printData, setPrintData] = useState(null);
  const [storeInfo, setStoreInfo] = useState();


  const { formatDate } = useFormattingUtils()
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });
  const { handleToast } = useToastHandler()
  const { Post, _Get, GetPaginatedData, Patch } = useApi();
  const { user } = useContext(AuthContext);
  const storeId = user.store;

  const handlePrint = (row) => {
    if (!row) return;

    setPrintData({
      ...row,
      store_info: row.store_info,
    });

    setOpenPrint(true);
  };



  useEffect(() => {
    const initializeData = async () => {
      // await fetchEmployees();
      // await fetchUsers();
      await fetchPayrollEmployees();
      await fetchBiomatricSalaryData();
    };
    initializeData();
  }, []);


  useEffect(() => {
    if (selectedEmployeeId && dateFrom && dateTo) {
      fetchCalculatedHours();
    }
  }, [selectedEmployeeId, dateFrom, dateTo]);



  useEffect(() => {
    if (payType && calculatedHours && baseAmount) {
      calculatePayAmount();
    }
  }, [payType, calculatedHours, baseAmount]);



  // const fetchEmployees = async () => {
  //   try {
  //     const response = await _Get("user");
  //     if (response && response.results) {
  //       setEmployees(response.results);
  //     } else {
  //       setEmployees([]);
  //     }
  //   } catch (error) {
  //     console.error("Error fetching employees:", error);
  //     setEmployees([]);
  //   }
  // };



  const fetchBiomatricSalaryData = async ({ page = 1, searchTerm = "" } = {}) => {
    try {
      setLoading(true);
      const response = await GetPaginatedData("payrollSalaryData", {
        page,
        search: searchTerm,
      });

      const storeInfoData = response?.rawResponse?.store_info || {};
      setStoreInfo(storeInfoData);

      const results = response?.data || [];
      const totalPages = Math.ceil((response?.totalCount || 0) / 10);

      const formatted = results
        .filter(item => item.is_bio === true)
        .map((item) => ({
          ...item,
          store_info: storeInfoData,
          date: item.date ? formatDate(item.date) : "N/A",
        }));

      setBioMatricSalary(formatted);
      return { data: formatted, totalPages };
    } catch (error) {
      console.error("Error fetching gas data:", error);
      handleToast({
        type: "ERROR",
        message: "Failed to fetch gas invoice data.",
      });
      setBioMatricSalary([]);
      return { data: [], totalPages: 1 };
    } finally {
      setLoading(false);
    }
  };


  const fetchSalaryDataForTable = async (params) => {
    const { data, totalPages } = await fetchBiomatricSalaryData(params);
    return { data, totalPages };
  };



  const fetchCalculatedHours = async () => {
    if (!selectedBioEmployeeId) {
      handleToast({
        type: "ERROR",
        message: "Please select an employee",
      });
      return;
    }
    if (!workingHoursPerDay) {
      handleToast({
        type: "ERROR",
        message: "Please enter working hours per day",
      });
      return;
    }
    if (!dateFrom || !dateTo) {
      handleToast({
        type: "ERROR",
        message: "Please select start and end date",
      });
      return;
    }
    try {
      setLoading(true);
      const response = await Post("faceTotalWorkedHours", {
        employee_id: selectedBioEmployeeId,
        start_date: dateFrom,
        end_date: dateTo,
        working_hours_per_day: parseFloat(workingHoursPerDay),
      });
      const data = response?.data || {};
      const totalHours =
        typeof data.total_hours === "number" ? data.total_hours : 0;
      const dailyLogs = Array.isArray(data.results) ? data.results : [];
      setDailyLog(dailyLogs);
      const totalMinutes = Math.round(totalHours * 60);
      const hoursPerWeek = parseFloat(workingHoursPerDay) * 5;
      const hoursPerMonth = hoursPerWeek * 4;
      const weeklyFraction = hoursPerWeek ? totalHours / hoursPerWeek : 0;
      const monthlyFraction = hoursPerMonth ? totalHours / hoursPerMonth : 0;
      setCalculatedHours({
        total: totalHours,
        totalMinutes,
        weeklyFraction,
        monthlyFraction,
        weeklyPercent: weeklyFraction * 100,
        monthlyPercent: monthlyFraction * 100,
      });
    } catch (error) {
      console.error("Error fetching calculated hours:", error);
      setDailyLog([]);
      setCalculatedHours(null);
      handleToast({
        type: "ERROR",
        message: "Failed to calculate worked hours",
      });
    } finally {
      setLoading(false);
    }
  };



  const calculatePayAmount = () => {
    if (!calculatedHours || !baseAmount) return;
    const amount = parseFloat(baseAmount);
    if (isNaN(amount)) {
      setPayAmount("0.00");
      return;
    }
    let totalAmount = 0;
    switch (payType) {
      case "Hourly":
        totalAmount = calculatedHours.total * amount;
        break;
      case "Weekly":
        totalAmount = calculatedHours.weeklyFraction * amount;
        break;
      case "Monthly":
        totalAmount = calculatedHours.monthlyFraction * amount;
        break;
      default:
        totalAmount = 0;
    }
    setPayAmount(totalAmount.toFixed(2));
  };
  const handleOpen = () => {
    setEditSalaryData(null);
    setSelectedEmployee("");
    setSelectedEmployeeId("");
    setPaySalaryModal(true);
  };
  const handleClose = () => {
    resetForm();
    setPaySalaryModal(false);
  };
  // const fetchUsers = async () => {
  //   try {
  //     const response = await _Get("user");
  //     if (response && response.results) {
  //       setUsers(response.results);
  //     } else {
  //       setUsers([]);
  //       handleToast({
  //         type: "ERROR",
  //         message: "Invalid response format from API"
  //       });
  //     }
  //   } catch (error) {
  //     console.error("Error fetching users:", error);
  //     setUsers([]);
  //     handleToast({
  //       type: "ERROR",
  //       message: "Error fetching users: " + error.message
  //     });
  //   }
  // };



  const fetchPayrollEmployees = async () => {
    try {
      const response = await _Get("payrollEmployeeData");
      if (response && response.results) {
        setPayrollEmployees(response.results);
      } else {
        setPayrollEmployees([]);
      }
    } catch (error) {
      console.error("Error fetching payrollEmployees:", error);
      setPayrollEmployees([]);
    }
  };


  const handleEmployeeChange = (event) => {
    const employeeId = event.target.value;
    setSelectedEmployee(employeeId);
    setSelectedEmployeeId(employeeId);
  };


  const handleWorkingHoursChange = (event) => {
    const value = event.target.value;
    if (parseFloat(value) > 24) {
      handleToast({
        type: "ERROR",
        message: "Working hours per day cannot exceed 24"
      })
      return;
    }
    setWorkingHoursPerDay(value);
  };


  const handleEditSalary = (id) => {
    const salaryRecord = biomatricSalary.find(record => record.id === id);
    if (salaryRecord) {
      setEditSalaryData(salaryRecord);
      setPaySalaryModal(true);

      const foundPayrollEmployee = payrollEmployees.find(pe => pe.id === salaryRecord.payroll_employee);

      setSelectedEmployee(salaryRecord.payroll_employee);
      setSelectedEmployeeId(salaryRecord.payroll_employee);
      setSelectedBioEmployeeId(foundPayrollEmployee?.employee_id || null);

      setBaseAmount(salaryRecord.salary_amount);
      setDateFrom(salaryRecord.start_date);
      setDateTo(salaryRecord.end_date);
      const capitalizedUnit = salaryRecord.salary_unit
        ? salaryRecord.salary_unit.charAt(0).toUpperCase() + salaryRecord.salary_unit.slice(1)
        : "";
      setPayType(capitalizedUnit);
      setWorkingHoursPerDay("8");
      setCalculatedHours(null);
      setPayAmount(salaryRecord.total_amount?.toString() || "");
      setDailyLog([]);
    }
  };


  const handlePaySalary = async () => {
    // if (!payAmount || isNaN(parseFloat(payAmount))) {
    //   handleToast({
    //     type: "ERROR",
    //     message: "Please fill in all required fields."
    //   });
    //   return;
    // }
    if (!calculatedHours || calculatedHours.total <= 0) {
      handleToast({
        type: "ERROR",
        message: "Please calculate working hours before confirming payment."
      });
      return;
    }
    if (!payAmount || isNaN(parseFloat(payAmount)) || parseFloat(payAmount) <= 0) {
      handleToast({
        type: "ERROR",
        message: "Invalid payment amount. Please check base rate and hours."
      });
      return;
    }
    if (!selectedEmployeeId || !payType || !dateFrom || !dateTo || !baseAmount) {
      handleToast({
        type: "ERROR",
        message: "Please fill in all required fields."
      });
      return;
    }
    if (!selectedEmployeeId || !payType || !dateFrom || !dateTo || !baseAmount) {
      handleToast({
        type: "ERROR",
        message: "Please fill in all required fields."
      });
      return;
    }
    const currentDate = new Date().toISOString().split('T')[0];
    const getSalaryUnit = (type) => {
      const mapping = { 'Hourly': 'hourly', 'Weekly': 'weekly', 'Monthly': 'monthly' };
      return mapping[type] || 'hourly';
    };
    const selectedPayrollEmployee = payrollEmployees.find(pe => pe.id === selectedEmployeeId);
    const userEmployee = employees.find(emp => emp.email === selectedPayrollEmployee?.email);


    const payload = {
      store: storeId,
      employee_id: selectedPayrollEmployee?.employee_id || null,
      payroll_employee: selectedEmployeeId,
      payroll_date: currentDate,
      start_date: dateFrom,
      end_date: dateTo,
      salary_unit: getSalaryUnit(payType),
      salary_amount: parseFloat(baseAmount),
      total_amount: parseFloat(payAmount),
      pay_method: "cash",

      total_hour: calculatedHours
        ? Number(calculatedHours.total.toFixed(2))
        : null,
      // total_hour: calculatedHours ? calculatedHours.totalMinutes : null,
      is_bio: true,
    };

    if (editSalaryData) {
      try {
        const response = await Patch("payrollSalaryData", editSalaryData.id, payload);
        if (response.status === 200 || response.status === 201) {
          handleToast({
            type: "SUCCESS",
            message: "Salary updated successfully!"
          });
          resetForm();
          handleClose();
          setSalaryHistoryRefreshKey((prev) => prev + 1);
          fetchBiomatricSalaryData();
        } else {
          handleToast({
            type: "ERROR",
            message: `Update failed: ${response.statusText}`,
          });
        }
      } catch (err) {
        handleToast({
          type: "ERROR",
          message: `Update error: ${err.message}`,
        });
      }
    } else {
      try {
        const response = await Post("payrollSalaryData", payload);
        if (response.status === 200 || response.status === 201) {
          handleToast({
            type: "SUCCESS",
            message: "Salary paid successfully!"
          });
          resetForm();
          handleClose();
          setSalaryHistoryRefreshKey((prev) => prev + 1);
          fetchBiomatricSalaryData();
        } else {
          handleToast({
            type: "ERROR",
            message: `Error paying salary: ${response.statusText}`,
          });
        }
      } catch (err) {
        const errorMessage = err.response?.data?.date_range?.[0] || err.message || "Error paying salary";
        handleToast({
          type: "ERROR",
          message: errorMessage,
        });
      }
    }
  };


  // const handleSnackbar = (message, severity) => {
  //   setSnackbar({
  //     open: true,
  //     message,
  //     severity,
  //   });
  // };


  const handleCloseSnackbar = () => {
    setSnackbar((prev) => ({
      ...prev,
      open: false,
    }));
  };


  const resetForm = () => {
    setPayAmount("");
    setBaseAmount("");
    setCalculatedHours(null);
    setSelectedEmployee("");
    setSelectedEmployeeId("");
    setUsername("");
    setPayType("");
    setDateFrom("");
    setDateTo("");
    setWorkingHoursPerDay("");
    setDailyLog([]);
  };


  const convertHoursToHMS = (decimalHours) => {
    const totalSeconds = Math.floor(decimalHours * 3600);
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;
    return `${hours}h : ${minutes}min : ${seconds}sec`;
  };


  const formatTime = (timeStr) => {
    if (!timeStr) return '';
    const [hours, minutes] = timeStr.split(':');
    return `${hours.padStart(2, '0')}:${minutes.padStart(2, '0')}`;
  };
  return {
    paySalaryModal,
    handleClose,
    handleOpen,
    employees,
    selectedEmployee,
    selectedEmployeeId,
    users,
    handleEmployeeChange,
    payAmount,
    baseAmount,
    calculatedHours,
    username,
    payType,
    dateFrom,
    dateTo,
    workingHoursPerDay,
    dailyLog,
    snackbar,
    handlePaySalary,
    handleCloseSnackbar,
    setPayType,
    setBaseAmount,
    setDateFrom,
    setDateTo,
    setWorkingHoursPerDay,
    convertHoursToHMS,
    formatTime,
    handleWorkingHoursChange,
    biomatricSalary,
    loading,
    fetchSalaryDataForTable,
    resetForm,
    handleEditSalary,
    editSalaryData,
    salaryHistoryRefreshKey,
    _Get,
    setSelectedEmployee,
    setSelectedEmployeeId,
    setSelectedBioEmployeeId,
    payrollEmployees,
    GetPaginatedData,
    openPrint,
    printData,
    handlePrint,
    setOpenPrint,
    setPrintData,
    storeInfo

  };
};
export default BiometricController;